export default "__VITE_ASSET__Dr29ECs9__"